import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';

export const RGPD_ROUTES: Routes = [
  {
    path: 'rgpd/manage',
    loadComponent: () => import('../features/rgpd/manage/manage.component').then(m => m.RgpdManageComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'rgpd/list',
    loadComponent: () => import('../features/rgpd/list/list.component').then(m => m.RgpdListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'rgpd/view',
    loadComponent: () => import('../features/rgpd/view/view.component').then(m => m.RgpdViewComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'rgpd/consents',
    loadComponent: () => import('../features/rgpd/consents/consents.component').then(m => m.RgpdConsentsComponent),
    canActivate: [AuthGuard],
  },
];
